<template>
  <v-autocomplete
      v-model="value"
      :items="values"
      :label="label"
      item-text="name"
      item-value="id"
      return-object
      hide-details
  />
</template>

<script>
import VueTypes from "vue-types";
import {ItemCollectMode} from "@/modules/redactor/models/item/ItemCollectMode";

export default {
  name: "r-item-collect-mode",
  props: {
    model: VueTypes.instanceOf(ItemCollectMode),
    label: VueTypes.string.def("Collect Mode:"),
  },
  computed: {
    value: {
      get: function () {
        return this.model;
      },
      set: function (value) {
        this.$emit("update:model", value);
      }
    },
    values() {
      return ItemCollectMode.getValues();
    }
  }
}

</script>